import React, { memo, useCallback, useEffect, useMemo, useState } from "react";
import AnyChart from "anychart-react";
import anychart from "anychart";
import Index from "../../Index";
import AutoWidthHeight from "../../common/AutoWidthHeight";
import moment from "moment";
import DrawChartButton from "../../modal/DrawChartButton";
import {
  manageChartDrawingData,
  manageChartInstance,
  manageDrawingChartToken,
} from "../../../redux/user/action";
import { toast } from "react-toastify";
import { DataService } from "../../../config/DataService";
import useCurrentInterval from "../../common/current-interval/useCurrentInterval";
import Constants from "../../common/constants";

var dataTable = {};

const CustomLineChart = (props) => {
  // Const declaration region
  const themeTitle = localStorage.getItem("default-theme");
  const dispatch = Index.useDispatch();
  const {
    angelListData,
    liveData,
    chartView,
    token: userToken,
    chartDrawingData,
    otherSettings,
    displaySettings,
    chartDuration,
    gridSpacing,
    gridBorder,
    isIntradayDurationChange,
    isFlip,
    graphType,
    twoSideArrowZoom,
    drawingStockToken,
    theme,
  } = Index.useSelector((state) => state.UserReducer);

  const lineGraph = Index.useSelector(
    (store) => store.UserReducer.GraphStyle[theme].lineGraph
  );
  const {
    index,
    DivideHeight,
    DivideWidth,
    shareData,
    borderRadiusClass,
    pageSetting,
    setCurrenChart,
    setDrawingChart,
    activeChart,
    chartLiveData,
    activeCursor,
    isMCXMarket,
    openDrawingChartModal,
    handleUpdateAnnotation,
    chartHeight,
  } = props;

  const { height, width } = AutoWidthHeight();
  const [getFontColor] = Index.useContrastColor();
  // State declaration region
  const [data1, setData1] = useState([]);
  const [date, setDate] = useState(moment().format("DD-MM-YYYY hh:mm A"));
  const [open, setOpen] = useState(0);
  const [high, setHigh] = useState(0);
  const [low, setLow] = useState(0);
  const [close, setClose] = useState(0);
  const [newChart, setNewChart] = useState(null);
  const [loading, setLoading] = useState(true);
  // const [chartHeight, setChartHeight] = useState(null);
  const [parentWidth, setParentWidth] = useState(null);
  const [currentInterval, nextInterval] = useCurrentInterval(
    +Constants.chartInterval[chartDuration[chartView]?.interval]?.value,
    chartLiveData,
    isMCXMarket
  );

  // Hooks declaration region
  useEffect(() => {
    props?.setCurrenChart && setCurrenChart(charts());
    // props?.setDrawingChart && setDrawingChart(charts());
  }, [
    chartDuration,
    lineGraph,
    DivideHeight,
    data1,
    // index,
    otherSettings?.[theme]?.crosshair?.color,
    otherSettings?.[theme]?.crosshair?.thickness,
    otherSettings?.[theme]?.crosshair?.lineType,
    otherSettings?.[theme]?.daySplitter,
    otherSettings?.[theme]?.scale,
    displaySettings?.TimeScale,
    displaySettings?.PriceScale,
    displaySettings?.PriceIndicator,
    displaySettings?.DaySplitter,
    document?.getElementsByClassName("chart-header-main")?.[0]?.clientHeight,
    chartView,
    gridSpacing,
    gridBorder,
    isFlip,
    activeChart,
    graphType[theme][chartView],
    twoSideArrowZoom,
    loading,
    chartHeight,
  ]); //Grid load restrict
  // }, [lineGraph, DivideHeight, data1, index, pageSetting ]);

  useEffect(() => {
    if (!openDrawingChartModal && drawingStockToken == index) {
      charts();
      dispatch(manageDrawingChartToken(null));
    }
  }, [openDrawingChartModal]);

  useEffect(() => {
    // if (chartView === "Positional") {
    setData1(shareData);
    // }
  }, [angelListData, shareData]);

  useEffect(() => {
    // if (chartView === "Intraday") {
    addPoint();
    // }
  }, [chartLiveData?.tick]);

  useEffect(() => {
    if (shareData?.length > 0) {
      // setTimeout(() => {
      setLoading(false);
      // }, 500);
    } else {
      setLoading(true);
    }
  }, [shareData]);

  const contrastColor = useMemo(() => {
    return getFontColor(lineGraph.color);
  }, [lineGraph?.color]);

  // Function declaration region
  const addPoint = () => {
    // append row of random values to data set
    if (shareData?.length >= 0 && chartLiveData?.tick) {
      dataTable[index].addData(shareData);
      let data = data1;
      const liveTimestamp = Index.moment(chartLiveData.tick[0])
        .subtract(5, "hours")
        .subtract(30, "minutes")
        .valueOf();

      if (liveTimestamp >= currentInterval && liveTimestamp < nextInterval) {
        data.pop();
        data.push([
          Index.moment(currentInterval)
            .add(5, "hours")
            .add(30, "minutes")
            .valueOf(),
          chartLiveData.tick[1],
          chartLiveData.tick[2],
          chartLiveData.tick[3],
          chartLiveData.tick[4],
          chartLiveData.tick[4],
        ]);
      } else {
        data?.push(chartLiveData.tick);
      }
      // data?.push(shareData && shareData[shareData?.length - 1]);
      const t = shareData?.length && shareData[shareData?.length - 1];
      // setDate(moment(t[0])?.format("DD-MM-YYYY hh:mm A"));
      // setOpen(t[1]);
      // setHigh(t[2]);
      // setLow(t[3]);
      // setClose(t[4]);
      setData1(data);
      dataTable[index].addData(data);
    }
  };
  // Chart drawing function declaration start
  const charts = () => {
    const container = document.getElementById(`line_chart${index}`);
    container?.firstElementChild?.remove();

    var chart = anychart.stock();
    chart.top(13);
    chart.left(-1);
    chart.right(displaySettings?.PriceScale === "on" ? 60 : 0);
    dataTable[index] = anychart.data.table();
    dataTable[index]?.addData(data1);
    // create a line series and set the data
    // dataTable[index].removeFirst(300)
    let series2 = dataTable[index].mapAs({
      open: 1,
      high: 2,
      low: 3,
      close: 4,
      value: chartView === "Positional" ? 4 : 5,
    });
    // value: 1,

    // Enable mouse wheel zoom.
    var interactivity = chart.interactivity();
    interactivity.zoomOnMouseWheel(true);

    var plot = chart.plot(0);
    plot.xAxis().enabled(displaySettings?.TimeScale === "on");

    if (props?.live) {
      plot
        .xAxis()
        .labels()
        .format((e) => {
          return anychart.format.dateTime(e["tickValue"], "HH:mm");
        });
    }

    chart.plot(0).yAxis().enabled(true);
    chart
      .plot(0)
      .yAxis()
      .stroke(
        otherSettings?.[theme]?.scale?.color,
        otherSettings?.[theme]?.scale?.thickness,
        otherSettings?.[theme]?.scale?.lineType
      );
    chart
      .plot(0)
      .yAxis(0)
      .ticks()
      .stroke(
        otherSettings?.[theme]?.scale?.color,
        otherSettings?.[theme]?.scale?.thickness
      );

    theme == "Light"
      ? plot.xAxis().background("#fff")
      : theme == "Dark"
      ? plot.xAxis().background("#212121")
      : plot.xAxis().background("#283142");

    plot.yAxis().enabled(true);
    plot.annotations(true);

    plot.yScale().inverted(isFlip);

    var extraYAxis = plot.yAxis();
    extraYAxis.orientation("right");

    //Price Indicator
    if (
      props?.live &&
      displaySettings?.PriceIndicator === "on" &&
      displaySettings?.PriceScale === "on"
    ) {
      let indicator = plot.priceIndicator();
      indicator.value("last-visible");
      indicator.stroke(lineGraph.color, 1, "4 2");
      indicator.label().background().fill(lineGraph.color);
      indicator.label().fontColor(contrastColor);
    }

    // create a line series
    var crosshair = chart.crosshair();
    crosshair.enabled(true);
    crosshair.xLabel().format(function (e) {
      const date = Index.moment(e.tickValue)
        .subtract(5, "hours")
        .subtract(30, "minutes");
      return date.hour() === 0 && date.minute() === 0
        ? date.format("DD MMM 'YY")
        : date.format("ddd DD MMM 'YY   HH:mm");
      // return anychart.format.dateTime(e["tickValue"], "YYYY MMM dd hh:mm");
    });

    crosshair.yLabel().format(function (e) {
      return this?.tickValue ? Number(this?.tickValue?.toFixed(2)) : 0;
    });

    // crosshair.displayMode("float");
    // crosshair.yLabel(true);
    // crosshair.xLabel(true);

    //Hide joint tooltip
    // chart.tooltip(false);

    // var yCrossLabel = chart.crosshair().yLabel();
    // yCrossLabel.format(function () {
    //   return this.value;
    // });

    //   var xCrossLabel = chart.crosshair().xLabel();
    //   xCrossLabel.format(function () {
    //   let date = new Date(this.rawValue);
    //   return moment.unix(this.rawValue).format("MMM DD YYYY hh:mm");
    // });

    if (theme == "Light") {
      crosshair.xStroke(
        otherSettings?.[theme]?.crosshair?.color || "#212121",
        otherSettings?.[theme]?.crosshair?.thickness || 1,
        otherSettings?.[theme]?.crosshair?.lineType || "4 3",
        "round"
      );
      crosshair.yStroke(
        otherSettings?.[theme]?.crosshair?.color || "#212121",
        otherSettings?.[theme]?.crosshair?.thickness || 1,
        otherSettings?.[theme]?.crosshair?.lineType || "4 3",
        "round"
      );
    } else {
      crosshair.xStroke(
        otherSettings?.[theme]?.crosshair?.color || "#ffffff",
        otherSettings?.[theme]?.crosshair?.thickness || 1,
        otherSettings?.[theme]?.crosshair?.lineType || "4 3",
        "round"
      );
      crosshair.yStroke(
        otherSettings?.[theme]?.crosshair?.color || "#ffffff",
        otherSettings?.[theme]?.crosshair?.thickness || 1,
        otherSettings?.[theme]?.crosshair?.lineType || "4 3",
        "round"
      );
    }
    // crosshair.xLabel().enabled(true);
    // crosshair.yLabel().enabled(!props?.live);
    var tooltip = chart.tooltip();
    tooltip.width(0);
    tooltip.height(0);
    tooltip.separator(false);
    // set chart padding
    chart.padding([0, 0, 0, 0]);
    // set chart background
    chart.background().fill({
      src: "",
      mode: "fit",
    });
    var background = chart.background();
    background.cornerType("round");
    background.fill(
      theme == "Light" ? "#fff" : theme == "Dark" ? "#212121" : "#283142"
    );
    plot.xGrid().enabled(false);
    plot.xGrid().stroke("#ffffff05");
    plot.yGrid().stroke("#ffffff05");
    theme == "Light"
      ? plot.xGrid().palette(["#fff"])
      : theme == "Dark"
      ? plot.xGrid().palette(["#212121"])
      : plot.xGrid().palette(["#ff0000"]);
    plot.yGrid().enabled(false);
    theme == "Light"
      ? plot.xGrid().palette(["#fff"])
      : theme == "Dark"
      ? plot.xGrid().palette(["#212121"])
      : plot.xGrid().palette(["#283142"]);
    chart.scroller().enabled(false);
    var lineSeries = plot.line(series2);
    lineSeries.stroke(function () {
      return {
        keys: [lineGraph.color],
        thickness: lineGraph.thickness,
      };
    });
    lineSeries.fill({
      keys: [lineGraph.color],
      fill: 2,
    });

    let mainGridHeight = document.getElementsByClassName(
      "dashboard-chart-main"
    )?.[0]?.clientHeight;

    let singleStockMainHeight =
      document.getElementsByClassName("single-stock-view")?.[0]?.clientHeight;

    let chartHeaderHeight =
      document.getElementsByClassName("chart-header-main")?.[0]?.clientHeight;

    // setChartHeight(
    //   (mainGridHeight -
    //     chartHeaderHeight * DivideHeight -
    //     (gridSpacing * 8 * (DivideHeight - 1) + 8) -
    //     (activeChart ? parseInt(gridBorder) * 4 : 0)) /
    //     DivideHeight
    // );

    var stage = anychart.graphics.create(
      `line_chart${index}`,
      "100%",
      chartHeight
      // (mainGridHeight -
      //       chartHeaderHeight * DivideHeight -
      //       (gridSpacing * 8 * (DivideHeight - 1) + 8) -
      //       (activeChart ? parseInt(gridBorder) * 4 : 0)) /
      //       DivideHeight
    );

    let chartBodySize =
      document.getElementsByClassName("chart-body")?.[0]?.clientWidth;

    setParentWidth(chartBodySize);

    plot.legend(false);
    chart.listen("eventMarkerClick", function (e) {});
    chart.listen("pointClick", function (e) {
      // var index = e.iterator.getIndex();
      // var row = dataTable[index].row(index);
    });
    tooltip.format(function (e) {
      if (data1 && e?.index && data1[e.index]) {
        // setDate(moment(data1[e?.index][0])?.format("DD-MM-YYYY hh:mm A"));
        // setOpen(data1[e.index][1]);
        // setHigh(
        //   chartView === "Positional" ? data1[e.index][1] : data1[e.index][5]
        // );
        // setLow(data1[e.index][3]);
        setClose(data1[e.index][4]);

        return chartView === "Positional"
          ? data1[e.index][1]
          : data1[e.index][5];
      }
    });
    // let timePrice = 0
    // let drawLineValue
    // drawLineValue = chart.plot(0).annotations().horizontalLine({ valueAnchor: 2790 });
    // drawLineValue.id = 0
    // setInterval(()=>{
    //   chart.plot(0).annotations().getAnnotationAt(0).valueAnchor(2790 + timePrice );
    //   timePrice += 20
    // },1000)

    //Drawing

    chart.listen("click", function (e) {
      props?.setDrawingChart && setDrawingChart({ chart, token: props?.token });
    });

    if (activeChart) {
      props?.setDrawingChart && setDrawingChart({ chart, token: props?.token });
    }

    if (!loading) {
      chart.container(stage).draw();
      chart.selectRange("points", 25, false);
      setNewChart(chart);
      drawingAnnotationLogic(chart);
      drawAnnotationsWithData(chart);
      handleDrawDaySplitter(plot, shareData);
      return chart;
    }
  };

  const handleDrawDaySplitter = (plot, stockData) => {
    if (
      chartView === "Positional" &&
      shareData?.length &&
      displaySettings?.DaySplitter === "on"
    ) {
      const groupedData = stockData.reduce((acc, curr) => {
        const date = Index.moment(curr[0]).startOf("day").valueOf();
        if (!acc[date]) {
          acc[date] = [];
        }
        acc[date].push(curr[0]);
        return acc;
      }, {});

      const filteredData = Object.values(groupedData).map(
        (group) => group[group.length - 1]
      );

      filteredData?.forEach((item, index) => {
        var marker = plot.lineMarker(index);
        marker.axis(plot.xAxis());
        marker.value(item);
        marker.stroke({
          thickness: otherSettings?.[theme]?.daySplitter?.thickness,
          color: otherSettings?.[theme]?.daySplitter?.color,
          dash: otherSettings?.[theme]?.daySplitter?.lineType,
        });
      });
    }
  };

  const drawingAnnotationLogic = (chart) => {
    if (chart) {
      //<<<<<<<<<<<<<<<<<<< Annotation Select >>>>>>>>>>>>>>>>>
      chart.listen("annotationSelect", function (event) {
        let selectedAnnotation = event?.annotation;
        props?.setDrawingChart &&
          setDrawingChart({ chart, token: props?.token });
      });

      // //<<<<<<<<<<<<<<<<<<< Annotation Unselect >>>>>>>>>>>>>>>>>
      chart.listen("annotationUnselect", function (event) {
        var unselectAnnotation = event.annotation;
        // dispatch(
        //   manageChartInstance({ chart, token: JSON.parse(props?.token) })
        // );
        // props?.setDrawingChart && setDrawingChart(null);
      });

      //<<<<<<<<<<<<<<<<<<< Annotation Change >>>>>>>>>>>>>>>>>
      chart.listen("annotationChange", function (event) {
        let changeAnnotation = event.annotation;
      });

      //<<<<<<<<<<<<<<<<<<< Annotation Change Start >>>>>>>>>>>>>>>>>
      chart.listen("annotationChangeStart", function (event) {
        let changeStartAnnotation = event.annotation;
      });

      // //<<<<<<<<<<<<<<<<<<< Annotation Change Finish >>>>>>>>>>>>>>>>>
      chart.listen("annotationChangeFinish", function (event) {
        // dispatch(manageChartInstance({ chart, token: props?.token }));
        let finishAnnotationChange = event.annotation;

        let myData = chart.plot(0).annotations().toJson();
        let dataToStore = myData?.annotationsList;

        if (props?.token) {
          let annotationData = {
            token: JSON.parse(props?.token),
            data: dataToStore,
            chartType: chartView,
            interval:
              Constants.annotationTimeFrames[
                chartDuration[chartView]?.interval
              ],
          };
          handleUpdateAnnotation(annotationData);
        }
      });

      // //<<<<<<<<<<<<<<<<<<< Annotation Drawing Finish >>>>>>>>>>>>>>>>>
      chart.listen("annotationDrawingFinish", function (event) {
        let finishAnnotationDrawing = event.annotation;

        let myData = chart.plot(0).annotations().toJson();
        let dataToStore = myData?.annotationsList;
        if (props?.token) {
          let annotationData = {
            token: +props?.token,
            data: dataToStore,
            chartType: chartView,
            interval:
              Constants.annotationTimeFrames[
                chartDuration[chartView]?.interval
              ],
          };

          handleUpdateAnnotation(annotationData);
        }
      });
    }
  };

  //Draw saved data
  function drawAnnotationsWithData(chart) {
    if (chart) {
      let savedData;

      if (chartDrawingData?.length > 0) {
        savedData = chartDrawingData?.find(
          (item) => item.token == +props?.token && item?.chartType == chartView
        );
      }

      const controller = chart.plot(0).annotations();

      if (
        savedData &&
        savedData?.data[
          Constants.annotationTimeFrames[chartDuration[chartView]?.interval]
        ]?.length > 0
      ) {
        savedData?.data[
          Constants.annotationTimeFrames[chartDuration[chartView]?.interval]
        ]?.forEach((annotationData) => {
          if (annotationData?.type == "ellipse") {
            controller.ellipse(annotationData);
          }
          if (annotationData?.type == "triangle") {
            controller.triangle(annotationData);
          }
          if (annotationData?.type == "trend-channel") {
            controller.trendChannel(annotationData);
          }
          if (annotationData?.type == "line") {
            controller.line(annotationData);
          }
          if (annotationData?.type == "andrews-pitchfork") {
            controller.andrewsPitchfork(annotationData);
          }
          if (annotationData?.type == "horizontal-line") {
            controller.horizontalLine(annotationData);
          }
          if (annotationData?.type == "fibonacci-fan") {
            controller.fibonacciFan(annotationData);
          }
          if (annotationData?.type == "vertical-line") {
            controller.verticalLine(annotationData);
          }
          if (annotationData?.type == "fibonacci-arc") {
            controller.fibonacciArc(annotationData);
          }
          if (annotationData?.type == "infinite-line") {
            controller.infiniteLine(annotationData);
          }
          if (annotationData?.type == "fibonacci-retracement") {
            controller.fibonacciRetracement(annotationData);
          }
          if (annotationData?.type == "ray") {
            controller.ray(annotationData);
          }
          if (annotationData?.type == "fibonacci-timezones") {
            controller.fibonacciTimezones(annotationData);
          }
          if (annotationData?.type == "marker") {
            controller.marker(annotationData);
          }
          if (annotationData?.type == "rectangle") {
            controller.rectangle(annotationData);
          }
        });
      }
    }
  }
  return (
    <>
      {/* <DrawChartButton newChart={newChart} token={+props?.token} /> */}
      <Index.Box className="custom_line_chart">
        <Index.Stack direction="row" className="chart_ohcl">
          {/* <Index.Typography
            sx={{ fontSize: parentWidth * 0.03 }}
            variant="caption"
            color="#5A76B4"
          >
            O : {open}; &nbsp;
          </Index.Typography>
          <Index.Typography
            sx={{ fontSize: parentWidth * 0.03 }}
            variant="caption"
            color="#00FF00"
          >
            H : {high}; &nbsp;
          </Index.Typography>
          <Index.Typography
            sx={{ fontSize: parentWidth * 0.03 }}
            variant="caption"
            color="#FF0000"
          >
            L : {low}; &nbsp;
          </Index.Typography> */}
          <Index.Typography
            sx={{ fontSize: parentWidth * 0.03 }}
            variant="caption"
            color="#5A76B4"
          >
            C : {close}
          </Index.Typography>
        </Index.Stack>
        {/* <Index.Stack direction="row" className="chart_ohcl chart_date">
          <Index.Typography variant="caption" color="#42506F">
            Date : {date};
          </Index.Typography>
        </Index.Stack> */}
        {loading && (
          <Index.Skeleton
            animation="wave"
            sx={{ bgcolor: "grey.1000" }}
            variant="rectangular"
            width={"100%"}
            height={chartHeight}
          />
        )}
        <div className={`loaded-chart-none ${loading ? "" : "loaded-chart"}`}>
          <AnyChart
            id={`line_chart${index}`}
            data={data1}
            className={`${borderRadiusClass}`}
          />
        </div>
      </Index.Box>
    </>
  );
};

export default memo(CustomLineChart);
